import Icon from '@ant-design/icons';

const TimerSvg = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.37825 16.5227L14.9663 10.2623C15.0069 10.2335 15.04 10.1955 15.0628 10.1512C15.0857 10.107 15.0976 10.058 15.0976 10.0082C15.0976 9.95838 15.0857 9.90932 15.0628 9.8651C15.04 9.82088 15.0069 9.7828 14.9663 9.75405L6.37825 3.49763C6.33124 3.46344 6.2757 3.44295 6.21778 3.43845C6.15986 3.43394 6.10183 3.44559 6.05011 3.47211C5.9984 3.49863 5.95502 3.53898 5.92479 3.58869C5.89457 3.63839 5.87867 3.69551 5.87885 3.75372V16.2666C5.87895 16.3247 5.89502 16.3816 5.92531 16.4311C5.9556 16.4807 5.99893 16.5209 6.05054 16.5473C6.10215 16.5738 6.16005 16.5855 6.21786 16.5811C6.27567 16.5768 6.33117 16.5566 6.37825 16.5227Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TimerPlay = (props: any) => <Icon component={TimerSvg} {...props} />;
